import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-md' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <img 
              src="/logo-primary-blue.png" 
              alt="Bharat Enterprises" 
              className="h-12 w-auto transition-transform hover:scale-105"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-steel-grey hover:text-bharat-blue transition-colors font-medium"
            >
              About Us
            </button>
            <button 
              onClick={() => scrollToSection('chemours')}
              className="text-steel-grey hover:text-bharat-blue transition-colors font-medium"
            >
              Chemours
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className="text-steel-grey hover:text-bharat-blue transition-colors font-medium"
            >
              Products
            </button>
            <button 
              onClick={() => scrollToSection('industries')}
              className="text-steel-grey hover:text-bharat-blue transition-colors font-medium"
            >
              Industries
            </button>
            <button 
              onClick={() => scrollToSection('why-us')}
              className="text-steel-grey hover:text-bharat-blue transition-colors font-medium"
            >
              Why Us
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-steel-grey hover:text-bharat-blue transition-colors font-medium"
            >
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-manufacturing-orange hover:bg-manufacturing-orange/90 text-white"
            >
              Get Quote
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-bharat-blue"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('about')}
                className="text-steel-grey hover:text-bharat-blue transition-colors font-medium text-left px-4"
              >
                About Us
              </button>
              <button 
                onClick={() => scrollToSection('chemours')}
                className="text-steel-grey hover:text-bharat-blue transition-colors font-medium text-left px-4"
              >
                Chemours
              </button>
              <button 
                onClick={() => scrollToSection('products')}
                className="text-steel-grey hover:text-bharat-blue transition-colors font-medium text-left px-4"
              >
                Products
              </button>
              <button 
                onClick={() => scrollToSection('industries')}
                className="text-steel-grey hover:text-bharat-blue transition-colors font-medium text-left px-4"
              >
                Industries
              </button>
              <button 
                onClick={() => scrollToSection('why-us')}
                className="text-steel-grey hover:text-bharat-blue transition-colors font-medium text-left px-4"
              >
                Why Us
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-steel-grey hover:text-bharat-blue transition-colors font-medium text-left px-4"
              >
                Contact
              </button>
              <div className="px-4">
                <Button 
                  onClick={() => scrollToSection('contact')}
                  className="w-full bg-manufacturing-orange hover:bg-manufacturing-orange/90 text-white"
                >
                  Get Quote
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
